// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var BillingProviderTransactionId = function (x) {
    return x;
};
var tsBridgeBillingProviderTr = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("BillingProviderTransactionId")("__brandBillingProviderTransactionId"));
    }
};
var writeBillingProviderTransactionId = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showBillingProviderTransactionId = Data_Show.showString;
var readBillingProviderTransactionId = Simple_JSON.readString;
var ordBillingProviderTransactionId = Data_Ord.ordString;
var newtypeBillingProviderTransactionId = {
    Coercible0: function () {
        return undefined;
    }
};
var makeBillingProviderTransactionId = BillingProviderTransactionId;
var eqBillingProviderTransactionId = Data_Eq.eqString;
export {
    BillingProviderTransactionId,
    makeBillingProviderTransactionId,
    unwrap,
    newtypeBillingProviderTransactionId,
    eqBillingProviderTransactionId,
    ordBillingProviderTransactionId,
    showBillingProviderTransactionId,
    readBillingProviderTransactionId,
    writeBillingProviderTransactionId,
    tsBridgeBillingProviderTr
};
//# sourceMappingURL=index.js.map
